import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";

// Data for benefits with associated images
const benefitData = [
  {
    id: 1,
    text: "Industry’s best fundraising success rate",
    image: "https://3.imimg.com/data3/OT/MD/MY-9055888/success-rate.png", // Example check icon
  },
  {
    id: 2,
    text: "Supported by 55,00,000+ donors",
    image: "https://media.istockphoto.com/id/625736338/photo/stack-of-hands-showing-unity.jpg?s=612x612&w=0&k=20&c=20mAQjGRQ5XVKqHe2qFguqGZ4dwto6lxxinciCfnVI0=", // Example people icon
  },
  {
    id: 3,
    text: "Easy-to-manage tools to boost results",
    image: "https://media.licdn.com/dms/image/C4D12AQHVnY4t2fOT2A/article-cover_image-shrink_720_1280/0/1520179476432?e=2147483647&v=beta&t=eipJ0GrtvRXEfcuUstMB6bsmvXHjDFI5FDh9vLUj_vo", // Example tools icon
  },
  {
    id: 4,
    text: "Receive donations via all popular payment modes",
    image: "https://www.shutterstock.com/image-vector/set-different-payment-systems-method-260nw-2304102381.jpg", // Example credit card icon
  },
  {
    id: 5,
    text: "Get expert support 24/7",
    image: "https://www.shutterstock.com/image-vector/24-hours-servises-icon-robotic-260nw-2338531739.jpg", // Example support icon
  },
  {
    id: 6,
    text: "A dedicated smart-dashboard",
    image: "https://www.hashstudioz.com/images/dashboard/need-for-effective-image-building.webp", // Example dashboard icon
  },
  {
    id: 7,
    text: "Withdraw funds without hassle",
    image: "https://www.shareindia.com/wp-content/uploads/2023/01/Withdraw-Money-from-a-Trading-Account.webp", // Example money icon
  },
  {
    id: 8,
    text: "International payment support",
    image: "https://img.freepik.com/premium-vector/men-makes-international-money-transfer-sending-money-around-world_530733-2900.jpg?semt=ais_hybrid", // Example globe icon
  },
];

// Framer Motion variants for animation
const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0, transition: { duration: 1.5 } },
};

const WhyUs = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true });

  return (
    <div className="mt-12 p-8 bg-gray-50">
      <motion.h2
        className="text-4xl font-bold text-center mb-10 text-gray-800"
        ref={sectionRef}
      >
        Why Donate Great?
      </motion.h2>
      <p className="text-center mb-6">
        Learn why "Donate Great" stands out in the world of fundraising and
        donations.
      </p>
      <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefitData.map(({ id, text, image }) => (
            <motion.li
                        whileHover={{scale:1.02}}
                      key={id}
                      className="relative bg-black p-1 h-52 shadow-md rounded-md text-center font-semibold hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out"
                      variants={cardVariants}
                      initial="hidden"
                      animate={isInView ? "visible" : "hidden"} // Trigger animation only when in view
                    >
                      {/* Image background */}
                      <div
                        className="absolute inset-0 bg-cover bg-center rounded-md opacity-70 hover:cursor-pointer"
                        style={{ backgroundImage: `url(${image})` }}
                      ></div>
          

            {/* Benefit Text */}
            <div className="relative z-10 text-white">
              <p className="text-lg font-bold">{text}</p>
            </div>
          </motion.li>
        ))}
      </ul>
    </div>
  );
};

export default WhyUs;
